import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Link } from "react-router-dom";

import {
    getScrewOilInjectFlowByInletPressure,
    getScrewOilInjectOutletPressure,
    getScrewOilInjectInletFlow,
    getCoolingTypes
} from "../../constants/sizing-constant";

export default class AirScrewOilInject extends Component {
    state = {
        inletFlow: [],
        selectedInletFlow: "0",

        coolingType: [],
        selectedCoolingType: "0",

        outletPressure: [],
        selectedOutletPressure: "0",

        suggestedModel: "",
        suggestedModelId: ""
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    componentDidMount() {
        this.setState({ outletPressure: [...getScrewOilInjectOutletPressure()] });
        this.setState({ inletFlow: [...getScrewOilInjectInletFlow()] });
        this.setState({ coolingType: [...getCoolingTypes()] });
    };

    handleOutletPressure = outletPressure => {
        if (outletPressure) {
            this.setState({ selectedOutletPressure: outletPressure.value }, () => {
                this.fillInputFlow();
                this.findModel();
            });
        }
    };

    handleInletFlowSelect = inletFlow => {
        if (inletFlow) {
            this.setState({ selectedInletFlow: inletFlow.value }, () => {
                this.findModel();
            });
        }
    };

    handleCoolingTypeSelect = coolingType => {
        if (coolingType) {
            this.setState({ selectedCoolingType: coolingType.value }, () => {
                this.findModel();
            });
        }
    };

    fillInputFlow() {
        const selectedOutletPressure = this.state.selectedOutletPressure;
        if (selectedOutletPressure === "1") {
            this.setState({ inletFlow: [...getScrewOilInjectFlowByInletPressure(selectedOutletPressure)] });
        }
        if (selectedOutletPressure === "2") {
            this.setState({ inletFlow: [...getScrewOilInjectFlowByInletPressure(selectedOutletPressure)] });
        }
        if (selectedOutletPressure === "3") {
            this.setState({ inletFlow: [...getScrewOilInjectFlowByInletPressure(selectedOutletPressure)] });
        }
    }

    findModel() {
        const selectedOutletPressure = this.state.selectedOutletPressure;
        const selectedInletFlow = this.state.selectedInletFlow;
        const selectedCoolingType = this.state.selectedCoolingType;

        if (selectedOutletPressure === "1") {
            if (selectedInletFlow === "1") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 2400  یا HYBW 2400" });
                    this.setState({ suggestedModelId: "128" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 2400" });
                    this.setState({ suggestedModelId: "129" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 2400" });
                    this.setState({ suggestedModelId: "130" });
                }
            }
            else if (selectedInletFlow === "2") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 3000  یا HYBW 3000" });
                    this.setState({ suggestedModelId: "131" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 3000" });
                    this.setState({ suggestedModelId: "132" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 3000" });
                    this.setState({ suggestedModelId: "133" });
                }
            }
            else if (selectedInletFlow === "3") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 4000  یا HYBW 4000" });
                    this.setState({ suggestedModelId: "134" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 4000" });
                    this.setState({ suggestedModelId: "135" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 4000" });
                    this.setState({ suggestedModelId: "136" });
                }
            }
            else if (selectedInletFlow === "4") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 5000  یا HYBW 5000" });
                    this.setState({ suggestedModelId: "137" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 5000" });
                    this.setState({ suggestedModelId: "138" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 5000" });
                    this.setState({ suggestedModelId: "139" });
                }
            }
            else if (selectedInletFlow === "5") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 6000  یا HYBW 6000" });
                    this.setState({ suggestedModelId: "140" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 6000" });
                    this.setState({ suggestedModelId: "141" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 6000" });
                    this.setState({ suggestedModelId: "142" });
                }
            }
            else if (selectedInletFlow === "6") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 8000  یا HYBW 8000" });
                    this.setState({ suggestedModelId: "143" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 8000" });
                    this.setState({ suggestedModelId: "144" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 8000" });
                    this.setState({ suggestedModelId: "145" });
                }
            }
            else if (selectedInletFlow === "7") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 10000  یا HYBW 10000" });
                    this.setState({ suggestedModelId: "146" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 10000" });
                    this.setState({ suggestedModelId: "147" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 10000" });
                    this.setState({ suggestedModelId: "148" });
                }
            }
            else if (selectedInletFlow === "8") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 13000  یا HYBW 13000" });
                    this.setState({ suggestedModelId: "149" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 13000" });
                    this.setState({ suggestedModelId: "150" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 13000" });
                    this.setState({ suggestedModelId: "151" });
                }
            }
            else if (selectedInletFlow === "9") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 15000  یا HYGW 15000" });
                    this.setState({ suggestedModelId: "152" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 15000" });
                    this.setState({ suggestedModelId: "153" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 15000" });
                    this.setState({ suggestedModelId: "154" });
                }
            }
            else if (selectedInletFlow === "10") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 19000  یا HYGW 19000" });
                    this.setState({ suggestedModelId: "155" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 19000" });
                    this.setState({ suggestedModelId: "156" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 19000" });
                    this.setState({ suggestedModelId: "157" });
                }
            }
            else if (selectedInletFlow === "11") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 23000  یا HYGW 23000" });
                    this.setState({ suggestedModelId: "158" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 23000" });
                    this.setState({ suggestedModelId: "159" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 23000" });
                    this.setState({ suggestedModelId: "160" });
                }
            }
            else if (selectedInletFlow === "12") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 28000  یا HYGW 28000" });
                    this.setState({ suggestedModelId: "161" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 28000" });
                    this.setState({ suggestedModelId: "162" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 28000" });
                    this.setState({ suggestedModelId: "163" });
                }
            }
            else if (selectedInletFlow === "13") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 34000  یا HYGW 34000" });
                    this.setState({ suggestedModelId: "164" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 34000" });
                    this.setState({ suggestedModelId: "165" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 34000" });
                    this.setState({ suggestedModelId: "166" });
                }
            }
            else if (selectedInletFlow === "14") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 45000  یا HYGW 45000" });
                    this.setState({ suggestedModelId: "167" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 45000" });
                    this.setState({ suggestedModelId: "168" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 45000" });
                    this.setState({ suggestedModelId: "169" });
                }
            }
        }
        else if (selectedOutletPressure === "2") {
            if (selectedInletFlow === "1") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 2400  یا HYBW 2400" });
                    this.setState({ suggestedModelId: "128" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 2400" });
                    this.setState({ suggestedModelId: "129" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 2400" });
                    this.setState({ suggestedModelId: "130" });
                }
            }
            else if (selectedInletFlow === "2") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 3000  یا HYBW 3000" });
                    this.setState({ suggestedModelId: "131" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 3000" });
                    this.setState({ suggestedModelId: "132" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 3000" });
                    this.setState({ suggestedModelId: "133" });
                }
            }
            else if (selectedInletFlow === "3") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 4000  یا HYBW 4000" });
                    this.setState({ suggestedModelId: "134" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 4000" });
                    this.setState({ suggestedModelId: "135" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 4000" });
                    this.setState({ suggestedModelId: "136" });
                }
            }
            else if (selectedInletFlow === "4") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 5000  یا HYBW 5000" });
                    this.setState({ suggestedModelId: "137" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 5000" });
                    this.setState({ suggestedModelId: "138" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 5000" });
                    this.setState({ suggestedModelId: "139" });
                }
            }
            else if (selectedInletFlow === "5") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 6000  یا HYBW 6000" });
                    this.setState({ suggestedModelId: "140" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 6000" });
                    this.setState({ suggestedModelId: "141" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 6000" });
                    this.setState({ suggestedModelId: "142" });
                }
            }
            else if (selectedInletFlow === "6") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 8000  یا HYBW 8000" });
                    this.setState({ suggestedModelId: "143" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 8000" });
                    this.setState({ suggestedModelId: "144" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 8000" });
                    this.setState({ suggestedModelId: "145" });
                }
            }
            else if (selectedInletFlow === "7") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 10000  یا HYBW 10000" });
                    this.setState({ suggestedModelId: "146" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 10000" });
                    this.setState({ suggestedModelId: "147" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 10000" });
                    this.setState({ suggestedModelId: "148" });
                }
            }
            else if (selectedInletFlow === "8") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 13000  یا HYBW 13000" });
                    this.setState({ suggestedModelId: "149" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 13000" });
                    this.setState({ suggestedModelId: "150" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 13000" });
                    this.setState({ suggestedModelId: "151" });
                }
            }
            else if (selectedInletFlow === "9") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 15000  یا HYGW 15000" });
                    this.setState({ suggestedModelId: "152" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 15000" });
                    this.setState({ suggestedModelId: "153" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 15000" });
                    this.setState({ suggestedModelId: "154" });
                }
            }
            else if (selectedInletFlow === "10") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 19000  یا HYGW 19000" });
                    this.setState({ suggestedModelId: "155" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 19000" });
                    this.setState({ suggestedModelId: "156" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 19000" });
                    this.setState({ suggestedModelId: "157" });
                }
            }
            else if (selectedInletFlow === "11") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 23000  یا HYGW 23000" });
                    this.setState({ suggestedModelId: "158" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 23000" });
                    this.setState({ suggestedModelId: "159" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 23000" });
                    this.setState({ suggestedModelId: "160" });
                }
            }
            else if (selectedInletFlow === "12") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 28000  یا HYGW 28000 یا HYDA 28000  یا HYDW 28000" });
                    this.setState({ suggestedModelId: "161" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 28000 یا HYDW 28000" });
                    this.setState({ suggestedModelId: "162" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 28000 یا HYDA 28000" });
                    this.setState({ suggestedModelId: "163" });
                }
            }
            else if (selectedInletFlow === "13") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 34000  یا HYGW 34000" });
                    this.setState({ suggestedModelId: "164" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 34000" });
                    this.setState({ suggestedModelId: "165" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 34000" });
                    this.setState({ suggestedModelId: "166" });
                }
            }
            else if (selectedInletFlow === "14") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 45000  یا HYGW 45000" });
                    this.setState({ suggestedModelId: "167" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 45000" });
                    this.setState({ suggestedModelId: "168" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 45000" });
                    this.setState({ suggestedModelId: "169" });
                }
            }
        }
        else if (selectedOutletPressure === "3") {
            if (selectedInletFlow === "1") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 2400 یا HYBW 2400" });
                    this.setState({ suggestedModelId: "128" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 2400" });
                    this.setState({ suggestedModelId: "129" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 2400" });
                    this.setState({ suggestedModelId: "130" });
                }
            }
            else if (selectedInletFlow === "2") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 3000  یا HYBW 3000" });
                    this.setState({ suggestedModelId: "131" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 3000" });
                    this.setState({ suggestedModelId: "132" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 3000" });
                    this.setState({ suggestedModelId: "133" });
                }
            }
            else if (selectedInletFlow === "3") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 4000  یا HYBW 4000" });
                    this.setState({ suggestedModelId: "134" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 4000" });
                    this.setState({ suggestedModelId: "135" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 4000" });
                    this.setState({ suggestedModelId: "136" });
                }
            }
            else if (selectedInletFlow === "4") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 5000  یا HYBW 5000" });
                    this.setState({ suggestedModelId: "137" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 5000" });
                    this.setState({ suggestedModelId: "138" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 5000" });
                    this.setState({ suggestedModelId: "139" });
                }
            }
            else if (selectedInletFlow === "5") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 6000  یا HYBW 6000" });
                    this.setState({ suggestedModelId: "140" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 6000" });
                    this.setState({ suggestedModelId: "141" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 6000" });
                    this.setState({ suggestedModelId: "142" });
                }
            }
            else if (selectedInletFlow === "6") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 8000  یا HYBW 8000" });
                    this.setState({ suggestedModelId: "143" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 8000" });
                    this.setState({ suggestedModelId: "144" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 8000" });
                    this.setState({ suggestedModelId: "145" });
                }
            }
            else if (selectedInletFlow === "7") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 10000  یا HYBW 10000" });
                    this.setState({ suggestedModelId: "146" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 10000" });
                    this.setState({ suggestedModelId: "147" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 10000" });
                    this.setState({ suggestedModelId: "148" });
                }
            }
            else if (selectedInletFlow === "8") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYBA 13000  یا HYBW 13000" });
                    this.setState({ suggestedModelId: "149" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYBW 13000" });
                    this.setState({ suggestedModelId: "150" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYBA 13000" });
                    this.setState({ suggestedModelId: "151" });
                }
            }
            else if (selectedInletFlow === "9") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 15000  یا HYGW 15000" });
                    this.setState({ suggestedModelId: "152" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 15000" });
                    this.setState({ suggestedModelId: "153" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 15000" });
                    this.setState({ suggestedModelId: "154" });
                }
            }
            else if (selectedInletFlow === "10") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 19000  یا HYGW 19000" });
                    this.setState({ suggestedModelId: "155" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 19000" });
                    this.setState({ suggestedModelId: "156" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 19000" });
                    this.setState({ suggestedModelId: "157" });
                }
            }
            else if (selectedInletFlow === "11") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 23000  یا HYGW 23000" });
                    this.setState({ suggestedModelId: "158" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 23000" });
                    this.setState({ suggestedModelId: "159" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 23000" });
                    this.setState({ suggestedModelId: "160" });
                }
            }
            else if (selectedInletFlow === "12") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 28000  یا HYGW 28000 یا HYDA 28000  یا HYDW 28000" });
                    this.setState({ suggestedModelId: "161" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 28000 یا HYDW 28000" });
                    this.setState({ suggestedModelId: "162" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 28000 یا HYDA 28000" });
                    this.setState({ suggestedModelId: "163" });
                }
            }
            else if (selectedInletFlow === "13") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 34000  یا HYGW 34000" });
                    this.setState({ suggestedModelId: "164" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 34000" });
                    this.setState({ suggestedModelId: "165" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 34000" });
                    this.setState({ suggestedModelId: "166" });
                }
            }
            else if (selectedInletFlow === "14") {
                if (selectedCoolingType === "0") {
                    this.setState({ suggestedModel: "HYGA 45000  یا HYGW 45000" });
                    this.setState({ suggestedModelId: "167" });
                }
                else if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYGW 45000" });
                    this.setState({ suggestedModelId: "168" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYGA 45000" });
                    this.setState({ suggestedModelId: "169" });
                }
            }
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.outletPressure}
                    placeholder="فشار خروجی کمپرسور (برحسب بار گیج)"
                    onItemSelect={this.handleOutletPressure}
                />
                {this.state.selectedOutletPressure !== "0" &&
                    <DropDownWhiteStyle
                        items={this.state.inletFlow}
                        placeholder="فلو کمپرسور بر حسب متر مکعب بر دقیقه (m^3/min)"
                        onItemSelect={this.handleInletFlowSelect}
                    />
                }
                {this.state.selectedInletFlow !== "0" &&
                    <DropDownWhiteStyle
                        items={this.state.coolingType}
                        placeholder="نوع خنک کننده"
                        onItemSelect={this.handleCoolingTypeSelect}
                    />
                }
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description"> پیشنهاد این مدل کمپرسور بر اساس شرایط محل نصبی، با فشار ۱ barA و دمای ۲۰  درجه سانتی گراد انجام شده است</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
